import { useLottie } from "lottie-react";
import {
  Button,
  IllustrationAnimation,
  IllustrationCol,
  IllustrationContainer,
  Section,
  SingleRow,
  TextCol,
  Text,
  TextContainer,
  Title,
  IllustrationLightbulb,
  NodesIllustration,
  ButtonContainer,
  InsightButton,
  Link,
} from "./styled";
import lightbulb from "../../../assets/img/lightbulb.svg";
import frontpageAnimation from "../../../assets/animations/panda.json";
import contactAnimation from "../../../assets/animations/contact.json";
import nodesMap from "../../../assets/img/nodes_map.png";
import Scroll from "react-scroll";

const Index = ({ isFrontpage }) => {
  const options = {
    animationData: isFrontpage ? frontpageAnimation : contactAnimation,
    loop: true,
  };

  const scroller = Scroll.scroller;
  const { View } = useLottie(options);

  const clickPortfolio = () => {
    scroller.scrollTo("portfolio", {
      duration: 1500,
      offset: -100,
    });
  };

  if (isFrontpage) {
    return (
      <Section>
        <SingleRow>
          <TextCol
            xs={{ span: 12, order: 2 }}
            md={{ span: 6, order: 1 }}
            className="my-auto"
          >
            <TextContainer>
              <Title>
                We are Camilla Pihl and Peter Peters - and we’re invested in{" "}
                <span className="weight">good ideas</span>.
              </Title>
              <Text>
                We create, build, and partner with outstanding companies on
                projects where commerce intersects with culture. Our passion
                lies in consistently crafting innovative and enhanced solutions
                that brighten everyday life.
              </Text>
              <Button onClick={clickPortfolio}>Portfolio</Button>
            </TextContainer>
          </TextCol>
          <IllustrationCol
            xs={{ span: 12, order: 1 }}
            md={{ span: 6, order: 2 }}
            className="my-auto"
          >
            <IllustrationContainer>
              <IllustrationLightbulb src={lightbulb} />
              <IllustrationAnimation>{View}</IllustrationAnimation>
            </IllustrationContainer>
          </IllustrationCol>
        </SingleRow>
      </Section>
    );
  }
  return (
    <Section>
      <SingleRow>
        <TextCol xs={12} md={5} className="my-auto">
          <TextContainer>
            <Title>About us</Title>
            <Text>
              Peters & Pihl Ventures is a boutique venture company operating at
              the crossroads of commerce and culture. Founded by longtime
              partners in life and business, Camilla Pihl and Peter Peters, the
              firm reflects over two decades of shared entrepreneurial
              experience. While conventional wisdom warns, “never mix business
              with friends or family,” they’ve built a company that proudly does
              exactly that. PPV is a family-driven enterprise that thrives on
              collaboration with the trusted circle of friends and family who
              have shaped their journey — and they wouldn’t have it any other
              way.
            </Text>
          </TextContainer>
          <ButtonContainer>
            <Link href="https://www.proff.no/selskap/peters-pihl-ventures-as/oslo/faglig-vitenskapelig-og-teknisk-virksomhet/IF3SK9C10N7">
              <InsightButton>Peters & Pihl Ventures AS</InsightButton>
            </Link>
            <Link href="https://www.proff.no/selskap/peters-pihl-holding-as/oslo/bedriftsrådgivning/IGHYBU1043Z">
              <InsightButton>Peters & Pihl Holding AS</InsightButton>
            </Link>
            <Link href="https://www.proff.no/selskap/camilla-pihl-fashion-group-as/oslo/grossister/IF8LO3W10NS">
              <InsightButton>Camilla Pihl Fashion Group AS</InsightButton>
            </Link>
          </ButtonContainer>
        </TextCol>
        <IllustrationCol xs={12} md={7}>
          <IllustrationContainer>
            <IllustrationAnimation>
              <NodesIllustration src={nodesMap} />
            </IllustrationAnimation>
          </IllustrationContainer>
        </IllustrationCol>
      </SingleRow>
    </Section>
  );
};

export default Index;
